import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { camelize } from 'inflected';
import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import styles from './Checkboxes.scss';

export default function generateCheckbox(size) {
    const checkbox = class extends Component {
        componentDidMount() {
            this.handleIndeterminate();
        }

        componentDidUpdate() {
            this.handleIndeterminate();
        }

        // indeterminate can *only* be handled through JS DOM properties
        handleIndeterminate() {
            if (this.checkbox) {
                this.checkbox.indeterminate = this.props.indeterminate;
            }
        }

        // the Sass for these checkboxes uses a)n <input type="checkbox" /> as a
        // backing store for the styles to be put onto the sibling <label>, so
        // we need to preserve that approach here.
        render() {
            const { checked = false, disabled = false, children, rawChildren } = this.props;
            const inputProps = { checked, disabled };
            const content = children || ' ';

            const passthroughProps = omit(
                this.props, 'rawChildren', 'checked',
                'disabled', 'children', 'indeterminate', 'forceHover',
            );
            const dataState =
        ['checked', 'disabled', 'indeterminate']
            .filter(which => this.props[which])
            .sort((a, b) => a.localeCompare(b))
            .join('-');

            let finalContent = content;
            if (!rawChildren) {
                finalContent = (<span className={styles['checkbox-text']}>
                    {content}
                </span>);
            }

            /* eslint-disable jsx-a11y/label-has-for */
            return (
                <span
                    data-state={dataState}
                    className={styles[`checkbox-${size}`]}
                    {...passthroughProps}
                >
                    <input
                        ref={(_c) => { this.checkbox = _c; }}
                        className={styles['checkbox-hidden']}
                        readOnly
                        type="checkbox"
                        {...inputProps}
                    />
                    <label className={styles[`checkbox-label${disabled ? '-active-disabled' : ''}`]}>
                        <span className={styles['checkbox-box']} />
                        {finalContent}
                    </label>
                </span>
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    };

    checkbox.displayName = displayName(`Forms/Checkboxes/${camelize(size)}Checkbox`);

    checkbox.propTypes = {
        checked: PropTypes.bool,
        indeterminate: PropTypes.bool,
        disabled: PropTypes.bool,
        children: PropTypes.node,
        rawChildren: PropTypes.bool,
        onClick: PropTypes.func,
    };

    checkbox.defaultProps = {
        checked: false,
        indeterminate: false,
        disabled: false,
        children: null,
        rawChildren: false,
        onClick: () => {},
    };

    return checkbox;
}
